var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.369 73.4251C112.637 75.3468 108.574 76.7801 104.247 77.6262C79.5848 82.4481 55.6834 66.3646 50.8615 41.7026C50.0155 37.3756 49.813 33.072 50.1875 28.8908C32.6474 37.9221 22.4102 57.74 26.3861 78.075C31.208 102.737 55.1094 118.821 79.7714 113.999C100.106 110.023 114.609 93.075 116.369 73.4251Z",
    fill: "#3CE05A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4865 28.7765C59.5967 27.1751 62.9825 25.9806 66.5884 25.2756C87.14 21.2573 107.058 34.6603 111.076 55.2119C111.781 58.8178 111.95 62.4041 111.638 65.8885C108.528 67.49 105.142 68.6844 101.536 69.3894C80.9843 73.4077 61.0664 60.0048 57.0481 39.4531C56.3431 35.8473 56.1744 32.2609 56.4865 28.7765Z",
    fill: "#3CE05A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 134,
    height: 134,
    rx: 67,
    stroke: "#3CE05A",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullMoon);
export default __webpack_public_path__ + "static/media/full-moon.ff7552394e33bf3405d4db6b4d0e5292.svg";
export { ForwardRef as ReactComponent };